import React from 'react';
import { IconWrapper, SvgIcon } from '../../../../../components/Icon';
import KubitTooltip from '../../../../../components/KubitTooltip';

interface IProps {
  onClick: () => void;
  isActive: boolean;
  isLoading: boolean;
  disabled: boolean;
}

const DashboardCustomizationsTrigger = ({
  onClick,
  isActive,
  isLoading,
  disabled,
}: IProps) => {
  return (
    <KubitTooltip
      content={
        isLoading
          ? 'Filters are not available while reports are loading.'
          : 'Add a custom dashboard filter.'
      }
      disabled={disabled}
      placement="bottom-end"
      noOpenDelay={true}
    >
      <IconWrapper size={24} onClick={onClick}>
        <SvgIcon
          name="filter"
          width={16}
          height={16}
          isActive={isActive}
          isDisabled={disabled}
        />
      </IconWrapper>
    </KubitTooltip>
  );
};

export default DashboardCustomizationsTrigger;
